<template>
  <div class="w120 mt20 mc">
    <el-menu :default-active="activeIndex" mode="horizontal" @select="goPage">
      <el-menu-item index="byHall" v-if="routeJur.counts01">大厅统计</el-menu-item>
      <el-menu-item index="byDept" v-if="routeJur.counts04">部门统计</el-menu-item>
      <el-menu-item index="byCollege" v-if="routeJur.counts03">学院统计</el-menu-item>
      <el-menu-item index="byPersonal">个人统计</el-menu-item>
    </el-menu>

    <transition name="el-zoom-in-to" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "serveCount",
  data() {
    return {
      activeIndex: ""
    };
  },
  computed: {
    ...mapState(["routeJur"])
  },
  mounted() {
    this.initIndex();
  },
  methods: {
    initIndex() {
      this.activeIndex = this.$route.name;
    },
    goPage(index) {
      // console.log(index);
      this.$router.push({
        name: index
      });
    }
  },
  watch: {
    $route() {
      this.initIndex();
    }
  }
};
</script>
